"use client";

import { ArrowRight } from "lucide-react";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { track } from "@/components/analytics/track";

/**
 * Soft paid-product upsell shown after a visitor can read the full note.
 * Kept out of notebook cells so it does not collide with the free email gate
 * or change cell-count preview %.
 */
export function ResearchProductCta() {
  const t = useTranslations("Research");

  return (
    <aside
      className="mt-14 rounded-xl border border-slate-700/70 bg-slate-900/60 p-6 md:p-7"
      aria-labelledby="research-product-cta-title"
    >
      <p className="text-xs uppercase tracking-wide text-slate-400 mb-2">
        {t("productCtaEyebrow")}
      </p>
      <h2
        id="research-product-cta-title"
        className="text-xl font-semibold text-slate-100 mb-3"
      >
        {t("productCtaTitle")}
      </h2>
      <p className="text-slate-400 text-sm leading-relaxed mb-3 max-w-xl">
        {t("productCtaLead")}
      </p>
      <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-xl">
        {t("productCtaMore")}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          href="/product"
          onClick={() =>
            track("cta_click", { meta: { label: "research_qi_download" } })
          }
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-maroon hover:bg-maroon-hover px-5 py-2.5 text-sm font-semibold text-white transition-colors"
        >
          {t("productCtaButton")}
          <ArrowRight className="h-4 w-4" aria-hidden />
        </Link>
        <Link
          href="/pricing"
          onClick={() =>
            track("cta_click", { meta: { label: "research_qi_pricing" } })
          }
          className="inline-flex items-center justify-center rounded-lg border border-slate-600 px-5 py-2.5 text-sm font-medium text-slate-300 hover:border-slate-400 hover:text-slate-100 transition-colors"
        >
          {t("productCtaSecondary")}
        </Link>
      </div>
    </aside>
  );
}
